export default __webpack_public_path__ + "static/trainingChildren-923067e7277aef2aad3404b1c220a9e3.png";